// Normalize: trim strings; empty string -> undefined; preserve numbers/booleans/objects/dates
const normalizeValue = (val) => {
  if (typeof val !== 'string') return val;

  const trimmed = val?.trim();

  return trimmed === '' ? undefined : trimmed;
};

export const generateCustomerPayload = (customer) => {
  const validatedCustomer = customer || {};

  return Object.entries(validatedCustomer).reduce((acc, [key, value]) => {
    const normalized = normalizeValue(value);

    if (normalized === undefined || normalized === null) {
      return acc;
    }

    return {
      ...acc,
      [`${key}`]: normalized,
    };
  }, {});
};

export const generateInsuredPersonPayload = (insuredPerson) => {
  const validatedInsuredPerson = insuredPerson || {};

  return Object.entries(validatedInsuredPerson).reduce((acc, [key, value]) => {
    const normalized = normalizeValue(value);

    if (normalized === undefined || normalized === null) {
      return acc;
    }

    return {
      ...acc,
      [`${key}`]: normalized,
    };
  }, {});
};

export const generateInsuredPersonForMePayload = (customer, insuredPerson) => {
  const validatedCustomer = customer || {};
  const validatedInsuredPerson = insuredPerson || {};

  const allKeys = new Set([
    ...Object.keys(validatedCustomer),
    ...Object.keys(validatedInsuredPerson),
  ]);

  return [...allKeys].reduce((acc, key) => {
    const normalizedCustomerValue = normalizeValue(validatedCustomer[`${key}`]);
    const normalizedInsuredPersonValue = normalizeValue(validatedInsuredPerson[`${key}`]);

    const valueToUse = normalizedCustomerValue ?? normalizedInsuredPersonValue;

    if (valueToUse === undefined || valueToUse === null) {
      return acc;
    }

    return {
      ...acc,
      [`${key}`]: valueToUse,
    };
  }, {});
};

export const generateInsuredPetPayload = (insuredPet) => {
  const validatedInsuredPet = insuredPet || {};

  return Object.entries(validatedInsuredPet).reduce((acc, [key, value]) => {
    const normalized = normalizeValue(value);

    if (normalized === undefined || normalized === null) {
      return acc;
    }

    return {
      ...acc,
      [`${key}`]: normalized,
    };
  }, {});
};
